const PASSWORD_COOKIE = "meme_admin_password";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

export const getStoredPassword = () => {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${PASSWORD_COOKIE}=`));

  return cookie
    ? decodeURIComponent(cookie.split("=").slice(1).join("="))
    : null;
};

export const storePassword = (password) => {
  document.cookie = `${PASSWORD_COOKIE}=${encodeURIComponent(
    password
  )}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
};

export const checkStoredOrPromptPassword = (expectedPassword) => {
  const storedPassword = getStoredPassword();

  if (storedPassword === expectedPassword) {
    return true;
  }

  const password = prompt("Password", "");
  const passwordMatches = password === expectedPassword;

  if (passwordMatches) {
    storePassword(password);
  }

  return passwordMatches;
};
